// src/components/ClientLayout.js
import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AuthContext } from "../context/AuthContext";
import Loader from "./components/Loader";

const ClientLayout = () => {
   const { loading } = useContext(AuthContext);
  return (
    <>
    
      <Navbar />
      <div className="   min-h-screen">
        {loading? <Loader/> :  <Outlet /> }
      </div>

      <Footer />
    </>
  );
};

export default ClientLayout;
